import { apiFetch } from "#lib/api";
import { IPost } from "#entities/posts";

export async function fetchProfilePosts(
  service: string,
  profileID: string,
  offset?: number,
  query?: string,
  tags?: string[]
) {
  const path = `/${service}/user/${profileID}/posts`;
  const params = new URLSearchParams();

  if (offset) {
    params.set("o", String(offset));
  }

  if (query) {
    params.set("q", query);
  }

  if (tags && tags.length) {
    for (const tag of tags) {
      params.append("tag", tag);
    }
  }

  const result = await apiFetch<IPost[]>(path, { method: "GET" }, params);

  return result;
}
